import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
import '@/filter'

import '../node_modules/bootstrap/dist/css/bootstrap.css'

/*** Setup Help Hub core component ***/
var headElement = document.getElementsByTagName("head")[0];
var vueScriptElement = document.createElement("script");
vueScriptElement.src = "https://del6fkf4zntcx.cloudfront.net/js/vue.min.js";
headElement.appendChild(vueScriptElement);
var componentScriptElement = document.createElement("script");
componentScriptElement.src = process.env.VUE_APP_HH_COMPONENTS_URL + "/helphubcore.umd.min.js?v=" + Date.now();
headElement.appendChild(componentScriptElement);

var componentStyleElement = document.createElement("link");
componentStyleElement.type = "text/css";
componentStyleElement.rel = "stylesheet";
componentStyleElement.href = process.env.VUE_APP_HH_COMPONENTS_URL + "/theme.css?v=1"
headElement.appendChild(componentStyleElement);

Vue.config.ignoredElements = ["help-hub-header"];

// includes() polyfill
import 'polyfill-array-includes'
// Scroll polyfill vue-autosuggest in IE/Edge
import smoothscroll from 'smoothscroll-polyfill'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSearch, faTh, faBars, faCircle, faInfoCircle, faArrowLeft, faTimes, faCheck, faStar as fasStar } from '@fortawesome/free-solid-svg-icons'
import { faStar as farStar } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import 'vue-good-table/dist/vue-good-table.css'

import './assets/style.css'
import './assets/helphub-header-overrides.css'
import phImage from "@/assets/app_placeholder.png";
import VueLazyload from 'vue-lazyload'
import TrackingMixin from '@/mixins/TrackingMixin'
import "@fortawesome/fontawesome-free/css/all.min.css"
 
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: phImage,
  attempt: 3,
  throttleWait: 1
})
 
smoothscroll.polyfill()

library.add(faSearch,faTh,faBars,faCircle,faInfoCircle,faArrowLeft,faTimes,faCheck, farStar, fasStar)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.mixin(TrackingMixin)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
